export default __webpack_public_path__ + "static/media/148.e8bcacec.jpg";